import { render } from "./TheTruongMamNon_PhongHoc.vue?vue&type=template&id=29c07e2a"
import script from "./TheTruongMamNon_PhongHoc.vue?vue&type=script&lang=js"
export * from "./TheTruongMamNon_PhongHoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__